// Admin-only create of an external call-center account (#1261). POST
// /call-center-agents (role forced to call_center_agent server-side).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CallCenterAccountSchema,
  type CallCenterAccount,
  type CreateCallCenterAccountInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useCreateCallCenterAccount() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<CallCenterAccount, unknown, CreateCallCenterAccountInput>({
    mutationFn: (input) =>
      client.post<CallCenterAccount>('/call-center-agents', input, {}, CallCenterAccountSchema),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['call-center-agents', 'list'] }),
  });
}
